<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item   prop="name" label="名称">
                        <el-input v-model="form.name" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="bindGradeIdstr" label="绑定年段">
                        <el-cascader
                            :options="bindGradeIdstrs"
                            v-model="form.bindGradeIdstr"
                            :props="props"
                            collapse-tags
                            clearable></el-cascader>
                    </el-form-item>

                    <el-form-item prop="checkUsers" label="拥有权限者">
                        <el-button @click="findUser(1)">{{form.checkUsersLabel}}</el-button>
                    </el-form-item>

                    <el-form-item prop="multipleApprover" label="审核人">
                        <el-button @click="findUser(2)">{{form.multipleApproverLabel}}</el-button>
                    </el-form-item>

                    <el-form-item  prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="20" type="number" style="width:200px;"></el-input>
                    </el-form-item>
                    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'
    import userTransfer from '../../sys/user/UserTransfer.vue' 

    export default {
        data(){
            return{
                visible: false,
                props: { multiple: true,  checkStrictly: true },
                transferVisible:false,
                form:{
                    deptId:"",
                    name:"",
                    type:"",
                    bindGradeIdstr:[],
                    checkUsers:[],
                    checkUsersLabel:"请选择",
                    multipleApprover:[],
                    multipleApproverLabel:"请选择",
                    orderNum:""
                },
                bindGradeIdstrs:[],
                source:1, // 1 绑定人员 2 审核人
                rules: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' }
                    ],
                    bindGradeIdstr: [
                        { required: true, message: '请选择年段', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        components: {
            userTransfer
        },
        methods:{
            init(deptId,type){
                this.form.type=type
                this.form.deptId=deptId

                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                this.form.checkUsers=[]
                this.form.checkUsersLabel="请选择"

                this.form.multipleApprover=[]
                this.form.multipleApproverLabel="请选择"
                // 加载绑定的部门
                this.getDeptCascader()
            },
            dialogClose(done){
                done()
                this.$reload
            },
            //部门
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.bindGradeIdstrs = res.data.selects
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let bindGradeId = this.filterCascader(this.form.bindGradeIdstr)

                        let url= this.classEvaluateTypeSavetUrl
                        let data = {
                            deptId:this.form.deptId,
                            name:this.form.name,
                            type:this.form.type,
                            bindGradeIdstr:bindGradeId,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:""
                        }

                        if(this.form.checkUsers.length > 0){
                            data['checkUsers']=this.form.checkUsers.join(',')
                        }
                        
                        if(this.form.multipleApprover.length > 0){
                            data['multipleApprover']=this.form.multipleApprover.join(',')
                        }
                        // console.log(JSON.stringify(data))
                        // return
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1)
                                this.visible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                        }, (err) => {
                            console.log(err)
                        });
                    }
               });
            },
            filterCascader(data){
                // 获取任意选项最后值
                let arrVal = new Array()
                for(var i=0; i<data.length;i++){
                    arrVal.push(data[i][data[i].length-1])
                }
               return arrVal.join()
            },
            // 绑定拥有权限与审核人
            findUser(source){
                this.transferVisible=true;
                this.$nextTick(() => {
                    // source 1 绑定人员 2 审核人
                    if(source == 1){  
                        if(this.form.checkUsers.length > 0){
                            this.$refs['userTransfer'].init(2,this.form.checkUsers,2,this.form.deptId)
                        }else{
                            this.$refs['userTransfer'].init(2,null,2,this.form.deptId)
                        }
                    }else if(source == 2){
                        if(this.form.multipleApprover.length > 0){
                            this.$refs['userTransfer'].init(2,this.form.multipleApprover,2,this.form.deptId)
                        }else{
                            this.$refs['userTransfer'].init(2,null,2,this.form.deptId)
                        }
                    }
                    this.source =source
                })
            },
            setUser(keyArr){
                if(this.source == 1){
                    if(keyArr.length == 0){
                        this.form.checkUsers=keyArr
                        this.form.checkUsersLabel="请选择"
                    }else{
                        this.form.checkUsers=keyArr
                        this.form.checkUsersLabel=keyArr.length+"人"
                    }
                }else if(this.source == 2){
                    if(keyArr.length == 0){
                        this.form.multipleApprover=keyArr
                        this.form.multipleApproverLabel="请选择"
                    }else{
                        this.form.multipleApprover=keyArr
                        this.form.multipleApproverLabel=keyArr.length+"人"
                    }
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classset/AddType.vue